var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "position-relative w-100" },
        [
          _c("b-form-input", {
            staticClass: "pointer-cell",
            attrs: {
              readonly: "",
              value: _vm.selectedValue,
              placeholder: "Выберите виды работ..."
            },
            on: { click: _vm.showModal }
          }),
          _vm._v(" "),
          _c("div", { staticClass: "select-input-body-wrapper" }, [
            _c(
              "button",
              {
                staticClass: "custom-btn-select",
                attrs: { type: "button" },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.onIconClick.apply(null, arguments)
                  }
                }
              },
              [
                _vm.selected.length > 0
                  ? _c("v-icon", { attrs: { name: "buttons/cross", size: 11 } })
                  : _c("v-icon", {
                      attrs: {
                        name: "buttons/collapse_chevrons_right",
                        size: 10
                      }
                    })
              ],
              1
            )
          ])
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "vacancy_multi_select_modal",
          attrs: {
            title: "Вакансии",
            size: "xl",
            "modal-class": "custom-modal",
            scrollable: ""
          },
          on: { close: _vm.onCancel },
          scopedSlots: _vm._u([
            {
              key: "modal-footer",
              fn: function() {
                return [
                  _c(
                    "div",
                    { staticClass: "d-flex justify-content-between w-100" },
                    [
                      _c("p", { staticClass: "float-left" }, [
                        _vm._v("Выбраны: " + _vm._s(_vm.tempSelected.length))
                      ]),
                      _vm._v(" "),
                      _c(
                        "b-button",
                        {
                          staticClass: "custom-btn-primary",
                          on: { click: _vm.onOk }
                        },
                        [_vm._v("\n          Применить\n        ")]
                      )
                    ],
                    1
                  )
                ]
              },
              proxy: true
            }
          ])
        },
        [
          _c(
            "div",
            { staticClass: "page-body" },
            [
              _c("div", { staticClass: "page-filters" }, [
                _c(
                  "div",
                  { staticClass: "d-flex align-items-center" },
                  [
                    _c(
                      "b-input-group",
                      [
                        _c("b-form-input", {
                          attrs: {
                            size: "sm",
                            placeholder: _vm.$t("message.common.search")
                          },
                          model: {
                            value: _vm.query,
                            callback: function($$v) {
                              _vm.query = $$v
                            },
                            expression: "query"
                          }
                        }),
                        _vm._v(" "),
                        _c("b-input-group-append", [
                          _c(
                            "button",
                            {
                              staticClass: "search-btn",
                              attrs: { type: "button" },
                              on: {
                                click: function($event) {
                                  $event.stopPropagation()
                                  return _vm.onSearch()
                                }
                              }
                            },
                            [
                              _c("v-icon", {
                                attrs: { name: "buttons/search" }
                              })
                            ],
                            1
                          )
                        ])
                      ],
                      1
                    )
                  ],
                  1
                )
              ]),
              _vm._v(" "),
              _vm.isBusy || (_vm.items && _vm.items.length > 0)
                ? [
                    _c(
                      "div",
                      { staticClass: "page-table-container" },
                      [
                        _c("b-table", {
                          ref: "vacancy_multi_select_table",
                          staticClass: "custom-table text-small mb-0",
                          attrs: {
                            id: "vacancy-multi-select-table",
                            responsive: "",
                            busy: _vm.isBusy,
                            items: _vm.items,
                            fields: _vm.fields,
                            "tbody-tr-class": _vm.tbodyRowClass,
                            "no-provider-filtering": "",
                            "no-provider-paging": "",
                            "no-provider-sorting": "",
                            "no-local-sorting": ""
                          },
                          on: {
                            "update:busy": function($event) {
                              _vm.isBusy = $event
                            },
                            "row-clicked": _vm.rowClicked,
                            "sort-changed": _vm.sortChanged
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "table-busy",
                                fn: function() {
                                  return [
                                    _c("tables-skeleton", {
                                      attrs: { fields: _vm.fields, rows: 5 }
                                    })
                                  ]
                                },
                                proxy: true
                              }
                            ],
                            null,
                            false,
                            168830385
                          )
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "page-pagination" },
                      [
                        _c("pagination-footer", {
                          attrs: {
                            "total-rows": _vm.totalRows,
                            "per-page": _vm.perPage,
                            "current-page": _vm.currentPage
                          },
                          on: {
                            "update:perPage": function($event) {
                              _vm.perPage = $event
                            },
                            "update:per-page": function($event) {
                              _vm.perPage = $event
                            },
                            "page-change": function(page) {
                              return _vm.onPagination(null, page)
                            },
                            "per-page-change": _vm.onPerPageChange
                          }
                        })
                      ],
                      1
                    )
                  ]
                : _c(
                    "div",
                    { staticClass: "empty-state-container" },
                    [
                      _c("v-icon", {
                        attrs: { name: "navbar/empty_table", size: 90 }
                      }),
                      _vm._v(" "),
                      _c("h5", [
                        _vm._v(
                          _vm._s(
                            _vm.isFiltered
                              ? "Нет данных соответствующих фильтрам."
                              : "Нет добавленных исполнителей."
                          )
                        )
                      ])
                    ],
                    1
                  )
            ],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-309e93c5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// /home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-309e93c5","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!/home/el/code/sverkasoft-erp/frontend/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Catalogs/Vacancies/VacancyMultiSelect.vue
// module id = null
// module chunks = 